import { render, staticRenderFns } from "./NewFormAutocomplete.vue?vue&type=template&id=a9233ff8&lang=pug&"
import script from "./NewFormAutocomplete.vue?vue&type=script&lang=js&"
export * from "./NewFormAutocomplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports